export default __webpack_public_path__ + "static/media/acae_logout.7fd9fa9b.svg";